var render = function render(){var _vm=this,_c=_vm._self._c;return _c('compare-project-bom',{attrs:{"productBom":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }